import { render, staticRenderFns } from "./sensorDataNew.vue?vue&type=template&id=55b6f7ee&scoped=true"
import script from "./sensorDataNew.vue?vue&type=script&lang=js"
export * from "./sensorDataNew.vue?vue&type=script&lang=js"
import style0 from "./sensorDataNew.vue?vue&type=style&index=0&id=55b6f7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6f7ee",
  null
  
)

export default component.exports